import { FC, ReactNode, useEffect, useState } from 'react';
import styled from 'styled-components';
import ShuttleHeader from '../shuttle/Header';

interface BlockProps {
  fontSize: string;
}

const Block = styled.div<BlockProps>`
  width: 100vw;

  * {
    font-size: ${props => props.fontSize};
  }

  .btn-primary:hover {
    background-color: #bb0665;
    border-color: #bb0665;
  }

  .table-shuttle {
    width: calc(100% - 20px);
    margin-left: auto;
    margin-right: auto;
    border-collapse: collapse;

    th, td {
      border: 1px solid #cccccc;
    }

    th {
      border-top: 2px solid #bb0665;
    }

    th:first-child,
    td:first-child {
      border-left: hidden;
    }

    th:last-child,
    td:last-child {
      border-right: hidden;
    }
  }

  .footer {
    position: fixed;
    bottom: 0;
    width: 100%;
    padding: 0;
    background: white;

    & > table {
      width: 100%;
      height: 50px;
      border-collapse: collapse;
      border-bottom: hidden;

      td {
        border: 1px solid #cccccc;
        font-size: 14px;
        font-weight: 600;
      }

      td:first-child {
        border-left: hidden;
      }

      td:last-child {
        border-right: hidden;
      }
    }
  }
`;

interface IProps {
  children: ReactNode;
}

const ShuttleLayout: FC<IProps> = ({ children }) => {
  const [fontOption, setFontOption] = useState(3);

  useEffect(() => {
    document.body.style.width = '100vw';
    document.body.style.backgroundColor = 'white';
    const content = document.querySelector('div.content');
    if (content) content.classList.add('w-100vw');
    const sidebar = document.querySelector('div.main-sidebar');
    if (sidebar) sidebar.classList.add('d-none');

    const _fontOption = localStorage.getItem('fontOption');
    if (_fontOption) setFontOption(Number(_fontOption));
  }, []);

  return (
    <Block fontSize = {String(fontOption * 2 + 7) + 'px'}>
      <ShuttleHeader
        fontOption={fontOption}
        setFontOption={setFontOption}
      />
      {children}
    </Block>
  );
}

export default ShuttleLayout;
